import { render, staticRenderFns } from "./CooperationLinks.vue?vue&type=template&id=06dbc1f9&scoped=true&"
import script from "./CooperationLinks.vue?vue&type=script&lang=js&"
export * from "./CooperationLinks.vue?vue&type=script&lang=js&"
import style0 from "./CooperationLinks.vue?vue&type=style&index=0&id=06dbc1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbc1f9",
  null
  
)

export default component.exports